import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import CardMedia from '@mui/material/CardMedia';

import Headline from '../components/blocks/shared/Headline';
import QuoteBlock from '../components/blocks/quoteBlock/QuoteBlock';
import GenericButton from '../components/blocks/shared/GenericButton';

import HfllPresentation from '../images/hfll_presentation.png';
import HfllCohort from '../images/hfll_cohort.png'

import { COLORS, SPACING } from '../theme.js';

const HfllPage = (props) => {
  const linkStyle = {
    textDecoration: "underline",
    color: COLORS.BLACK
  }

  return (
    <Stack>
      <Headline
        text="Harbor Freight Leadership Lab"
        headlineSx={{
          width: {xs: '100%', },
        }}
      />
      <Stack
        sx={{
          paddingLeft: SPACING.MAIN_LEFT,
          paddingRight: SPACING.MAIN_RIGHT,
          paddingBottom: { xs: '20px', sm: '30px', md: '40px', lg: '50px', xl: '60px' },
        }}
      >
        <Divider sx={{
          marginBottom: { xs: '20px', sm: '30px', md: '40px', lg: '50px', xl: '60px' },
        }} />
        <Grid container spacing={4}
          sx={{
          }}
        >

          {/* Intro */}
          <Grid item xs={12} sm={4} md={5} lg={5} xl={5}>
            <Box
              sx={{
                height: {xs: '200px', sm: '200px', md: '266px', lg: '266px'},
                padding: "12px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <img className="responsive-image" src={HfllPresentation} alt="HFLL meeting" />
            </Box>
          </Grid>

          <Grid item xs={12} sm={8} md={7} lg={7} xl={7}>
            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "CooperBTMedium",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem', lg: '1.8rem', xl: '2rem' },
                marginBottom: { xs: '1rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1rem' },
              }}
            >
              Lifting up skilled trades education
            </Typography>

            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              The Harbor Freight Leadership Lab brings together leaders from across the nation and K12 skilled trades education ecosystem—including school professionals, executives from industry and labor, and other key stakeholders—to deliver practical tools for career advancement, to forge deeper connections to one another and to elevate the skilled trades sector’s performance, prestige and standing in society.
            </Typography>
            <Box
              sx={{
                paddingTop: "10px"
              }}
            >
            </Box>
          </Grid>


          {/* Helping to... */}
          <Grid item xs={12}
            sx={{
              marginTop: { xs: '1rem', sm: '1rem', md: '1rem', lg: '2rem', xl: '2rem' },
              marginBottom: { xs: '1rem', sm: '1rem', md: '1rem', lg: '2rem', xl: '2rem' },
            }}
          >
            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "CooperBTMedium",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem', lg: '1.8rem', xl: '2rem' },
                marginBottom: { xs: '1rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1rem' },
              }}
            >
              Helping to make the next generation future-ready
            </Typography>

            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "CooperBTMedium",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem', lg: '1.4rem', xl: '1.4rem' },
                marginBottom: { xs: '0.5rem', sm: '0.5rem', md: '0.5rem', lg: '0.5rem', xl: '0.5rem' },
              }}
            >
              Dynamic
            </Typography>

            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              HFLL is a cohort-based learning experience that includes in-person convenings, collaborative online sessions and flexible, independent coursework for participants. Once the cohort year is complete, participants continue to enjoy opportunities to connect and work together virtually and in-person through our HFLL Alumni Network.
            </Typography>
            


            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "CooperBTMedium",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem', lg: '1.4rem', xl: '1.4rem' },
                marginTop: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
                marginBottom: { xs: '0.5rem', sm: '0.5rem', md: '0.5rem', lg: '0.5rem', xl: '0.5rem' },
              }}
            >
              Values-driven
            </Typography>

            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              HFLL is driven by the belief that all young people should be able to pursue a life of contribution and meaning. Career and technical education must be part of the equation. Too often, however, CTE is stigmatized and underfunded. HFLL is part of a national movement to remedy that.
            </Typography>
            


            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "CooperBTMedium",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem', lg: '1.4rem', xl: '1.4rem' },
                marginTop: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
                marginBottom: { xs: '0.5rem', sm: '0.5rem', md: '0.5rem', lg: '0.5rem', xl: '0.5rem' },
              }}
            >
              Impactful
            </Typography>

            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              A third-party assessment by Ascending Edge Creative Evaluation found that HFLL has deepened participants’ “enthusiasm for their work,” promoted “out-of-the-box thinking,” “shaped transformational ideas” and “played a vital role” in helping them “navigate the STE landscape, offering valuable advice…and connections to key resources.”
            </Typography>
            
          </Grid>


          {/* Quote Block */}
          <Grid item xs={12}
            sx={{
              marginTop: { xs: '1rem', sm: '1rem', md: '1rem', lg: '2rem', xl: '2rem' },
              marginBottom: { xs: '1rem', sm: '1rem', md: '1rem', lg: '2rem', xl: '2rem' },
            }}
          >
            <QuoteBlock
              sx={{
                height: { xs: '540px', sm: '520px', md: '600px', lg: '100%' },
              }}
            />
          </Grid>


          {/* Nomination Form */}
          <Grid item xs={12} sm={8} md={7} lg={7} xl={7}>
            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "CooperBTMedium",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem', lg: '1.8rem', xl: '2rem' },
                marginBottom: { xs: '1rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1rem' },
              }}
            >
              Would you like to be part of HFLL?
            </Typography>

            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
                marginBottom: { xs: '1rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1rem' },
              }}
            >
              We are now accepting nominations for our next cohort.
            </Typography>

            <Box sx={{ width: '100%' }} >
              <GenericButton
                text="Nomination Form"
                backgroundColor="#F4615F"
                borderColor="#F4615F"
                color="#000000"
                centerInParent={false}
                height={{ xs: '24px', sm: '28px', md: '34px', lg: '34px', xl: '40px' }}
                width={{ xs: '200px', sm: '200px', md: '200px', lg: '200px', xl: '300px' }}
                paddingTop={{ xs: '6px', sm: '8px', md: '10px', lg: '12px', xl: '14px' }}
                paddingBottom={{ xs: '6px', sm: '8px', md: '10px', lg: '12px', xl: '14px' }}
                paddingLeft={{ xs: '6px', sm: '8px', md: '10px', lg: '12px', xl: '14px' }}
                paddingRight={{ xs: '6px', sm: '8px', md: '10px', lg: '12px', xl: '14px' }}
                borderRadius={{ xs: '12px', sm: '18px', md: '20px', lg: '24px', xl: '24px' }}
                fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '20px', xl: '20px' }}
                onClick={() => { window.open('https://forms.fillout.com/t/5rp2nwMoiCus', '_blank'); }}
              />
            </Box>


            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
                marginTop: { xs: '1rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1rem' },
              }}
            >
              The Harbor Freight Leadership Lab (HFLL) launched in 2020 as a partnership between Harbor Freight Tools for Schools, a program of the Smidt Foundation, and the Bendable Labs team.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={4} md={5} lg={5} xl={5}>
            <Box
              sx={{
                height: {xs: '200px', sm: '200px', md: '266px', lg: '366px'},
                // height: '100%',
                display: "flex",
              }}
            >
              <CardMedia
                sx={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignContent: 'flex-end',
                  textAlign: 'center'
                }}
                image={HfllCohort}
              >
              </CardMedia>
            </Box>
          </Grid>


          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "CooperBTMedium",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem', lg: '1.8rem', xl: '2rem' },
                marginBottom: { xs: '1rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1rem' },
              }}
            >
              Alumni cohorts
            </Typography>

            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: { xs: '1.4rem', sm: '1.4rem', md: '1.4rem', lg: '1.4rem', xl: '1.4rem' },
              }}
            >
              Cohort 1 - 2020-2021
            </Typography>


            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              <ul style={{ listStyle: 'none', marginLeft: '-40px', marginTop: 0 }}>
                <li><b>Anthony Rodrigue</b>, CTE Coordinator Louisiana Virtual Charter Academy</li>
                <li><b>Danielle Labbé</b>, Dir. of Workforce Development Associated Builders and Contractors Pelican Chapter</li>
                <li><b>Gregory L. Jefferson, Sr.</b>, Legislative Representative AFL-CIO</li>
                <li><b>Joann Bellenkes</b>, Director of Training and Development Reborn Cabinets</li>
                <li><b>Kelly Carpenter</b>, Director of Education Associated Builders and Contractors Pelican Chapter</li>
                <li><b>Lesford Dixon</b>, Program Coordinator and Construction Instructor</li>
                <li><b>Melissa P. Caffrey</b>, Director of Multiple Pathways North Providence School District</li>
                <li><b>Nick Crimaldi</b>, United Brotherhood of Carpenters</li>
                <li><b>Roxanne Amiot</b>, Auto Technology Instructor Bullard-Havens High School</li> 
                <li><b>Tricia S. Jacobs</b>, Director of Career and Technical Education Alexandria City Public Schools</li>
              </ul>
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: { xs: '1.4rem', sm: '1.4rem', md: '1.4rem', lg: '1.4rem', xl: '1.4rem' },
              }}
            >
              Cohort 2 - 2021-2022
            </Typography>


            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              <ul style={{ listStyle: 'none', marginLeft: '-40px', marginTop: 0 }}>
                <li><b>Brent Tuttle</b>, Welding Instructor La Mirada High School, California</li>
                <li><b>Brian Manley</b>, Automotive Instructor, Cherry Creek Innovation Campus, Colorado</li>
                <li><b>Chad Sutton</b>, Dir. of Workforce Development, Lurleen B. Wallace Community College, Alabama</li>
                <li><b>Demetrius Wilson</b>, Engineering, Robotics, and Mechatronics Instructor, Oakland Technical Schools, Michigan</li>
                <li><b>Denise Kruser</b>, School Counselor, George S. Parker High School, Wisconsin</li>
                <li><b>Jolene Terrones</b>, Assistant Principal, George S. Parker High School, Wisconsin</li>
                <li><b>Kate Lee</b>, Exec. Director, Education & Workforce, South Bend Regional Chamber, Indiana</li>
                <li><b>Kyle Thompson</b>, Carpentry Instructor, Erwin Technical College, Florida</li>
                <li><b>Stephanie Davis</b>, President, The Greater Michigan Construction Academy, Michigan</li>
                <li><b>Tara Bell</b>, CTE Administrator, Cherry Creek Innovation Campus, Colorado</li>
                <li><b>Wendy Schepman</b>, Landscape Operations Teacher, South Fork High School, Florida</li>
                <li><b>Ziven Drake</b>, Training Coordinator, North Atlantic States Carpenters Training Fund, Massachusetts</li>
              </ul>
            </Typography>
          </Grid>


          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: { xs: '1.4rem', sm: '1.4rem', md: '1.4rem', lg: '1.4rem', xl: '1.4rem' },
              }}
            >
              Cohort 3 - 2022-2023
            </Typography>


            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.65rem', lg: '0.9rem', xl: '1rem'},
              }}
            >
              <ul style={{ listStyle: 'none', marginLeft: '-40px', marginTop: 0 }}>
                <li><b>Adrian Muñoz</b>, Makerspace Coordinator, Da Vinci Design High School, California</li>
                <li><b>Amy Foell</b>, Workforce Development Contractor, San Gabriel Valley Economic Partnership, California</li>
                <li><b>Beth White</b>, Regional Coordinator, Big Picture Learning; Founding Director, Habitat for Aviation, Vermont</li>
                <li><b>Charise Henry</b>, VP of Workforce Development, Brotherhood Crusade, California</li>
                <li><b>Chris Price</b>, Partner, The Mattison Corporation; President, Indiana Construction Roundtable Foundation, Indiana</li>
                <li><b>Erik Erazo</b>, Exec. Director of Student & Community Engagement, Olathe School District, Kansas</li>
                <li><b>Evin “Jarrett” Jarrett</b>, Construction Trades Instructor, School District of Philadelphia, Pennsylvania</li>
                <li><b>Jason Blackwell</b>, Education Specialist, Alabama State Department of Education, Alabama</li>
                <li><b>Jennifer Dewees</b>, President, Maryland Center for Construction Education and Innovation, Maryland</li>
                <li><b>Jomo Akono</b>, Council Representative, North Atlantic States Regional Council of Carpenters, New York</li>
                <li><b>Joy Patton</b>, Behavior and Restorative Practices Facilitator, La Vergne High School, Tennessee</li>
                <li><b>Juan Lopéz</b>, Dean, School of Advanced Manufacturing, Engineering and Applied Science, Ivy Tech, South Bend-Elkhart, Indiana</li>
                <li><b>Kirke Utecht</b>, Technology Education Teacher, School District of Janesville, Wisconsin</li>
                <li><b>Kyle Linko</b>, Supervisor of CTE, Career Technology Center of Lackawanna County, Pennsylvania</li>
                <li><b>Megan Anderson</b>, VP of Administration, Workforce Development Program Manager, CHERP, California</li>
                <li><b>Nicole Taylor</b>, School Counselor, Johns Creek High School, Georgia</li>
                <li><b>Peyton Holland</b>, Executive Director, National Technical Honor Society, North Carolina</li>
                <li><b>Rose Bomentre</b>, Superintendent, REAL Journey Academies, California</li>
                <li><b>Serena Jimmy</b>, CTE Director/Academic Coach, Chinle Unified School District, Arizona</li>
                <li><b>Shelley Adams</b>, Superintendent, Baldy View Regional Occupational Program, California</li>
                <li><b>Stacey Holsinger</b>, Owner, Steel Toe Communications, Maryland</li>
                <li><b>Thomas Arnett</b>, Senior Research Fellow, Clayton Christensen Institute, California</li>
              </ul>
            </Typography>
          </Grid>          

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: { xs: '1.4rem', sm: '1.4rem', md: '1.4rem', lg: '1.4rem', xl: '1.4rem' },
              }}
            >
              Cohort 4 - 2023-2024
            </Typography>


            <Typography
              component="div"
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              <ul style={{ listStyle: 'none', marginLeft: '-40px', marginTop: 0 }}>
                <li><b>Debbie Barnum</b>, Founder, WorkforceConnect, California</li>
                <li><b>Dionisio Tafoya</b>, Instructor and President, Dionysus Creative, LLC, California</li>
                <li><b>Eddie Hightower</b>, SVP, Sustainability, Caliber Collision, Texas</li>
                <li><b>Julian A. Rodriguez</b>, Superintendent, Southern California Regional Occupational Center, California</li>
                <li><b>Karen Minshew</b>, Assistant Superintendent, Educational Services, Cajon Valley Union School District, California</li>
                <li><b>Kathryn Tinnesz</b>, Founder, Owner and Lead Consultant, Space to Build, Virginia</li>
                <li><b>Mark Drury</b>, Founder, Mark Drury & Associates; President, DC Students Construction Trades Foundation, Maryland</li>
                <li><b>Matt Smith</b>, Principal, Garrett High School, Indiana</li>
                <li><b>Nerel Winter</b>, CEO, Bostonia Global, California</li>
                <li><b>Nolee Anderson-Hendren</b>, Program Specialist, Girls Representing In Trades; Owner, Joist Studio LLC, Montana</li>
                <li><b>Raul Pedraza Jr.</b>, Principal, Inland Career Education Center, SBCUSD, California</li>
                <li><b>Tony Indolino</b>, Instructor, IBEW, Local 11; Senior Street Light and Traffic Signal Mechanic, City of Pasadena, California</li>
                <li><b>Vanessa Tilford</b>, Career Coordinator, Bonita Unified School District, California</li>
              </ul>
            </Typography>
          </Grid>


          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              sx={{
                lineHeight: 1.5,
                fontFamily: "Sharp Sans",
                fontStyle: 'normal',
                fontWeight: '500',
                fontSize: {xs: '.8rem', sm: '.8rem', md: '.95rem', lg: '1rem'},
              }}
            >
              For more information, please email us at <a href="mailto:hfll@bendablelabs.com" style={{ color: '#000000'}}>hfll@bendablelabs.com</a>.
            </Typography>
          </Grid>




        </Grid>
      </Stack>
    </Stack>
  )
}

export default HfllPage;
